import { Component, Input } from '@angular/core';

@Component({
  selector: 'tree-node-content',
  template: `
    <span class="ecpl-node-content">
      {{ node?.data?.filename }}
    </span>
  `,
  standalone: false
})
export class TreeNodeContentComponent {
  @Input() node: any;
  @Input() index: number;
}
